module.exports = __webpack_public_path__ + "img/infinity.4a7ddfc1.svg";